// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__32Enh","additionalInfo":"AgreementModal_additionalInfo__2n90_"};